import {Observable, ReplaySubject, Subject} from 'rxjs';

export class WaterfallConfig {

    display: {
        type: DisplayType;
        subtitle: string, // string displayed under the breadcrumbs
        size?: ButtonSize, // item-buttons (input data from BE) size
        numberOfColumns: number, // not tested, default value is 2
        showSvg: boolean,  // show svgs in the item-buttons
        defaultSvg: string,  //fallback svg/icon if showSvg is true and item provides no svg
        buttons: {type: ActionButtonType, name: string, disableCond?: (item, object) => boolean,
            listener?: Subject<any>, style?: string, action?: Subject<ActionButtonType>}[], //action buttons at the bottom of modal -- next/back/cancel
        disableIfSelected?: boolean,
        showSeparator: boolean,
        separators: {title: string, groupItems: Observable<any[]>}[] //group input(s). Title of group and grouping seed
    };
    input: Observable<any[]>; // Data source
    onItemClicked: Subject<any>; //Pass control of item-buttons outside the TandemComponent
    child?: WaterfallConfig;  //nested configurations
    isRoot?: boolean = false; //true for the outmost screen
    skipDefault?: boolean = false; //if single item input, select it by default
    rootBreadcrumb?: {parentChoice: string, ancestorHistory: { name: string, levelTag: string }[]};
    levelTag: string; // Unique tag we compare against when we unwind during a breadcrumb clicked
    nameExtractor: (item) => string // Extract breadcrumb name from input
    templateName?: string;
    onClickOverrideSubject?: ReplaySubject<any>;
    manualProceed?: boolean = false;
    formGroupName?: string;
    formDriven?: boolean = false;
    mapChoiceToForm?: (event: any) => {}
    resetSeed?: any;
    resetPropagate?: any;
}

export enum ActionButtonType {
    Back, Next, Finish, Custom
}

export enum ButtonSize {
    Sm, Md, Lg, Xl, Custom
}

export enum DisplayType {
    Buttons, DropdownSingleSelect, Custom
}



// WEBPACK FOOTER //
// ./src/app/shared/components/waterfall/waterfall-config.ts